
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WPXFormValue } from '@/components/templates/WPXForm';
import RequestLogsForm from '@/services/WebsiteLog/forms/RequestLogsForm';
import { Website, WebsiteCreationAction } from '@/services/Website/interfaces';

@Component({
  mixins: [Themeable],
})
export default class RetryWebsiteCreationActionDialog extends Vue {
  @Prop() public domain!: string;

  @Prop() public creationId!: number;

  @Prop() public action!: WebsiteCreationAction;

  public visible: boolean = true;

  public recreateWebsite(): void {
    this.$emit('retryAction', this.creationId, this.action);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
